import { EducatorsReliefListingsInvitation } from "@/types/serializers"
import { useProps } from "@/lib/page-rendering"

export type NewProps = {
  invitation: EducatorsReliefListingsInvitation
}

export const useNewProps = () => useProps<NewProps>()
